import { useQuery } from 'react-query';
import customAxios from '../../../axios/custom-axios';

const getOrderItemsPdf = async (orderId) => {
  const token = localStorage.getItem('token');
  customAxios({
    method: 'get',
    responseType: 'arraybuffer',
    url: `/orders/${orderId}/items/pdf`,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `order_${orderId}.pdf`);
        document.body.appendChild(link);
        link.click();
      }
    });
};

const useGetOrderItemsPdf = (orderId) => useQuery(['itemsExcelFile', orderId], () => getOrderItemsPdf(orderId), { enabled: false });

export default useGetOrderItemsPdf;
